import { memo } from 'react';

const CommonDeleteBtn = ({ action, itemName, delId, isDelBtn = true }) => {
  return (
    <>
      {isDelBtn && (
        <i
          className="far fa-times-circle float-right pr-4"
          style={{ paddingTop: '.75rem' }}
          onClick={(e) => {
            e.stopPropagation();
            action(itemName, delId);
          }}
        ></i>
      )}
    </>
  );
};

export default memo(CommonDeleteBtn);
